module.exports = __webpack_public_path__ + "static/frontUserNew/img/typepdf.54c375a8.svg";